import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '@/components/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Dashboard.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/job/:id',
    name: 'JobDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/JobDetail.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/job/:id/:storeId',
    name: 'StoreDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/StoreDetail.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/store/log/:id/:storeId/:sku',
    name: 'StoreDetailLog',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/StoreDetailLog.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/activity/:id/:storeId',
    name: 'AllActivity',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/AllActivity.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/create',
    name: 'CreateJob',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/CreateJob.vue'
      ),
    meta: {
      requiresAuth: true,
      stockEdit: true,
    },
  },
  {
    path: '/stock/live',
    name: 'StockCard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/StockLive.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/stock/detail',
    name: 'StockDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/StockDetail.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/edit/:id',
    name: 'EditJob',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/EditJob.vue'),
    meta: {
      requiresAuth: true,
      stockEdit: true,
    },
  },
  {
    path: '/edit/:id/store/:storeId',
    name: 'EditStore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/EditStore.vue'
      ),
    meta: {
      requiresAuth: true,
      stockEdit: true,
    },
  },
  {
    path: '/ai-image-detection',
    name: 'AiImageDetection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/AiImageDetection.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store?.getters['auth/token']) {
      next({
        name: 'Login',
      })
    } else {
      // Get User Profile
      if (!store?.state?.me?.data) {
        await store.dispatch('me/getUserProfile')
      }

      if (
        to.meta.stockEdit &&
        !store?.state?.me?.data?.permission?.stock_edit
      ) {
        next({
          name: 'Login',
        })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
